import React from "react";
//local
import cn from "classnames";

export const VideoInstruction = ({
  url,
  title,
  size,
  containerSize,
  fitContainerSize,
  allowFullScreen,
  addClass,
}) => {
  const limitSizeClass = fitContainerSize ? "full-width full-height" : "";

  return (
    <div
      className={cn("", {
        [`wdth-${containerSize?.width}`]: !!containerSize,
        [`hght-${containerSize?.height}`]: !!containerSize,
        [addClass]: !!addClass,
      })}
    >
      <iframe
        src={url}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        className={limitSizeClass}
        width={size?.width}
        height={size?.height}
        allowFullScreen={allowFullScreen}
        style={{border: "none"}}
        title={title ?? "Vimeo video player"}
      />
      <script src="https://player.vimeo.com/api/player.js"></script>
    </div>
  );
};
